import styled from "styled-components"
import { globalMixins } from "../../../assets/styles/styled-components"

export const StyledHero = styled.div`
  width: 100%;
  margin: 0 auto 64px auto;
  display: flex;
  max-width: ${(props) => props.theme.breakPoints.wide};
  @media (max-width: 1264px) {
    max-width: ${(props) => props.theme.breakPoints.desktop};
  }
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    max-width: ${(props) => props.theme.breakPoints.tablet};
    flex-direction: column;
  }
`
export const StyledHeroCard = styled.div`
  padding: 32px;
  width: 50%;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0 8px 16px ${(props) => props.theme.colors.darkGrey10};
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 24px;
    width: 100%;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
    padding: 24px 16px;
  }
`
export const StyledHeroCardLogo = styled.div`
  display: ${(props) => (props.desktop ? "block" : "none")};
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    display: ${(props) => (props.tablet ? "block" : "none")};
  }

  & img {
    height: ${(props) => (props.desktop ? "68" : "44")}px;
  }
`
export const StyledHeroCardHeading = styled.h1`
  ${globalMixins.typography.h1}
  margin-top: 32px;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    margin-top: 24px;
  }
`
export const StyledHeroCardBody = styled.div`
  margin-top: 24px;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    margin-top: 16px;
  }

  & p {
    ${globalMixins.typography.body}
  }
`
export const StyledHeroCardCta = styled.div`
  display: flex;
  cursor: pointer;
  margin-top: 32px;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    margin-top: 24px;
  }

  & .button-v2 {
    pointer-events: none;
  }
`
export const StyledHeroCardOptions = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 32px -8px 0 -8px;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    margin: 24px -8px 0 -8px;
  }
`
export const StyledHeroCardOption = styled.a`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  cursor: pointer;
  margin: 8px;
`
const getOptionBackgroundColor = (props) => {
  switch (props.option) {
    case "linkedin":
      return "background-color: #3b62aa;"
    case "instagram":
      return "background: linear-gradient(to bottom, #6310ba 0%,#e31608 50%,#fed975 100%);"
    case "whatsapp":
      return "background-color: #59C96B;"
    case "sms":
      return "background-color: #58BE35;"
    case "messenger":
      return "background: linear-gradient(to bottom, #ff3f7a 0%,#952eff 50%,#1996ff 100%);"
    default:
      return `background-color: ${(props) => props.theme.colors.darkGrey};`
  }
}
const getOptionIconColor = (props) => {
  switch (props.option) {
    case "linkedin":
      return "color: #3b62aa;"
    case "instagram":
      return "color: red;"
    case "whatsapp":
      return "color: #59C96B;"
    case "sms":
      return "color: #58BE35;"
    case "messenger":
      return "color: red;"
    default:
      return `color: ${(props) => props.theme.colors.darkGrey};`
  }
}
export const StyledHeroCardOptionIcon = styled.div`
  min-width: 64px;
  max-width: 64px;
  min-height: 64px;
  max-height: 64px;
  border-radius: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  overflow: hidden;
  position: relative;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    ${getOptionBackgroundColor}
    width: 100%;
    height: 100%;
  }
  &:after {
    content: "";
    position: absolute;
    background: white;
    top: 2px;
    left: 2px;
    width: calc(100% - 4px);
    height: calc(100% - 4px);
    border-radius: 50%;
  }

  & svg {
    position: relative;
    z-index: 1;
    ${getOptionIconColor};
  }
  & img {
    max-width: 26px;
    position: relative;
    z-index: 1;
  }
`
export const StyledHeroImage = styled.div`
  background-color: ${(props) => props.theme.colors.darkGrey05};
  background-image: url("${(props) => props.image}");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  width: 50%;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    width: 100%;
    height: 400px;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
    height: 250px;
  }
`
export const StyledHeroCopyLink = styled.input`
  position: absolute;
  z-index: -1000000;
  left: -99999999999999px;
`
